const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

export async function apiFetch(path, { method = 'GET', headers = {}, body } = {}, getAccessToken) {
  const token = await getAccessToken?.();
  const h = { ...headers };
  if (!(body instanceof FormData)) {
    h['Content-Type'] = 'application/json';
  }
  if (token) h['Authorization'] = `Bearer ${token}`;
  const res = await fetch(`${API_URL}${path}`, {
    method,
    headers: h,
    body: body instanceof FormData ? body : body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let err;
    try {
      err = await res.json();
    } catch (e) {
      err = { message: res.statusText };
    }
    const e = new Error(err.message || 'Request failed');
    e.details = err.details;
    e.status = res.status;
    throw e;
  }
  const ct = res.headers.get('content-type') || '';
  if (ct.includes('application/json')) return res.json();
  return res.text();
}
